import { useLazyQuery, useMutation } from "@apollo/react-hooks";
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  Layout,
  message,
  Row,
  Table,
  TimePicker,
  Tooltip,
} from "antd";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { ProfileAvatar } from "../../../Components/Avatar";
import { Loader } from "../../../Components/Loader";
import { UPDATE_LOCATION_DATA } from "../../../Graphql/mutations";
import { GET_LOCATION_BY_ID } from "../../../Graphql/queries";
import "./LocationEdit.less";

const { Content } = Layout;

export const LocationEdit = ({ match, userTypeId }) => {
  const [timezone, setTimezone] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [openingTime, setOpeningTime] = useState("12:00");
  const [closingTime, setClosingTime] = useState("12:00");
  const [formSet, isFormSet] = useState(false);
  const user_id = localStorage.getItem("user_id");
  const type_id = userTypeId;
  const working_day = moment().format("dddd");
  const location_id = match.params.id;
  const [form, employeeSearchForm] = Form.useForm();
  const [GET_LOCATION_BY_ID_QUERY, { data, loading, previousData }] =
    useLazyQuery(GET_LOCATION_BY_ID, {
      fetchPolicy: "network-only",
    });
  const [UPDATE_LOCATION_MUTATION, { loading: updateLocationLoading }] =
    useMutation(UPDATE_LOCATION_DATA);
  const [DELETE_USER_MUTATION, { loading: deleteUserLoading }] =
    useMutation(UPDATE_LOCATION_DATA);
  useEffect(() => {
    GET_LOCATION_BY_ID_QUERY({
      variables: {
        user_id,
        type_id,
        working_day,
        location_id,
      },
    });
  }, []);

  useEffect(() => {
    async function fetchMyAPI() {
      let variables = {};
      variables.location_update_fields = {
        location_name: form.getFieldValue("location_name"),
        street_address: form.getFieldValue("street_address"),
        zipcode: form.getFieldValue("zipcode"),
        city: form.getFieldValue("city"),
        state: form.getFieldValue("state"),
        country: form.getFieldValue("country"),
        timezone_id: form.getFieldValue("timezone_id"),
        timezone_name: form.getFieldValue("timezone_name"),
      };
      variables.location_id = form.getFieldValue("location_id");
      variables.opening_time = moment(
        form.getFieldValue("opening_time"),
        moment.ISO_8601,
        true
      ).isValid()
        ? moment(form.getFieldValue("opening_time")).format("h:mm a")
        : form.getFieldValue("opening_time");
      variables.closing_time = moment(
        form.getFieldValue("closing_time"),
        moment.ISO_8601,
        true
      ).isValid()
        ? moment(form.getFieldValue("closing_time")).format("h:mm a")
        : form.getFieldValue("closing_time");
      const updateResponse = await UPDATE_LOCATION_MUTATION({
        variables: variables,
      });
      if (updateResponse.errors) {
        return false;
      } else {
        return true;
      }
    }
    return () => {
      if (Object.keys(form.getFieldValue()).length > 0) {
        fetchMyAPI();
      }
    };
  }, []);
  const handleZipcodeChange = async (e) => {
    if (
      !form.getFieldValue("zipcode") ||
      form.getFieldError("zipcode").length !== 0
    ) {
      return false;
    }
    const zipcode = e.target.value;
    let data = await axios.get(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${zipcode}&sensor=true&key=${process.env.REACT_APP_GOOGLE_MAP_API_KEY}`
    );
    if (data.data.status !== "OK") {
      message.error("Encountered error with zipcode. Please try again later.");
      return false;
    }
    if (data.data.results.length > 0) {
      let latLng =
        data.data.results[0].geometry.location.lat +
        "," +
        data.data.results[0].geometry.location.lng;
      let timeZoneData = await axios.get(
        `https://maps.googleapis.com/maps/api/timezone/json?location=${latLng}&timestamp=${moment().unix()}&key=${
          process.env.REACT_APP_GOOGLE_MAP_API_KEY
        }`
      );

      let addressComponents = data.data.results[0].address_components;
      let addrObj = {};
      addrObj["timezone_id"] = timeZoneData.data.timeZoneId;
      addrObj["timezone_name"] = timeZoneData.data.timeZoneName;
      setTimezone(timeZoneData.data.timeZoneName);
      addressComponents.forEach(({ types, long_name }) => {
        if (types.includes("locality")) {
          addrObj["city"] = long_name;
        }
        if (types.includes("administrative_area_level_2") && !addrObj["city"]) {
          addrObj["city"] = long_name;
        } else if (types.includes("administrative_area_level_1")) {
          addrObj["state"] = long_name;
        } else if (types.includes("country")) {
          addrObj["country"] = long_name;
        }
      });
      form.setFieldsValue(addrObj);
    }
  };

  const handleTimeChange = ({ time, timeString, type }) => {
    let fields = [];
    fields[type] = timeString;
    if (type === "opening_time") {
      setOpeningTime(timeString);
    }
    if (type === "closing_time") {
      setClosingTime(timeString);
    }
    form.setFieldsValue(fields);
  };
  useEffect(() => {
    if (data) {
      setTableData(
        data.getUserLocationMaps[0].locationDetails.user_location_maps
      );
      setOpeningTime(
        data.getUserLocationMaps[0].locationDetails.location_timings[0]
          ?.opening_time
      );
      setClosingTime(
        data.getUserLocationMaps[0].locationDetails.location_timings[0]
          ?.closing_time
      );
      form.setFields([
        {
          name: "location_name",
          value: data.getUserLocationMaps[0].locationDetails.location_name,
        },
        {
          name: "street_address",
          value: data.getUserLocationMaps[0].locationDetails.street_address,
        },
        {
          name: "zipcode",
          value: data.getUserLocationMaps[0].locationDetails.zipcode,
        },
        {
          name: "city",
          value: data.getUserLocationMaps[0].locationDetails.city,
        },
        {
          name: "state",
          value: data.getUserLocationMaps[0].locationDetails.state,
        },
        {
          name: "country",
          value: data.getUserLocationMaps[0].locationDetails.country,
        },
        {
          name: "location_id",
          value: data.getUserLocationMaps[0].locationDetails.location_id,
        },
        {
          name: "timezone_name",
          value: data.getUserLocationMaps[0].locationDetails.timezone_name,
        },
        {
          name: "opening_time",
          value: moment(
            data.getUserLocationMaps[0].locationDetails.location_timings[0]
              ?.opening_time,
            "h:mm a"
          ),
        },
        {
          name: "closing_time",
          value: moment(
            data.getUserLocationMaps[0].locationDetails.location_timings[0]
              ?.closing_time,
            "h:mm a"
          ),
        },
      ]);
      setTimezone(data.getUserLocationMaps[0].locationDetails.timezone_name);
      isFormSet(true);
    }
  }, [data]);

  const columns = [
    {
      title: "Employee name",
      key: "first_name",
      render: ({ userDetails }) => {
        return (
          <div className="d-flex align-items-center  profileSec">
            <div className="custAvatar">
              <ProfileAvatar
                name={userDetails.first_name + " " + userDetails.last_name}
              />
            </div>
            <div className="d-flex flex-column pl-3">
              <strong className="profileTop">
                {userDetails.first_name + " " + userDetails.last_name}
              </strong>
            </div>
          </div>
        );
      },
    },
    {
      title: "Employee role",
      key: "age",
      render: ({ jobRoleDetails }) => {
        return <div>{jobRoleDetails.role_name}</div>;
      },
    },

    // {
    //   title: "Action",
    //   key: "action",
    //   align: "center",
    //   render: ({ userDetails }) => (
    //     <Space
    //       size="middle"
    //       className="text-center d-flex justify-content-center"
    //     >
    //       {/* <span className="cursorPointer edit" onClick={showModal}>
    //         <CustIcon type="edit" />
    //       </span> */}
    //       {/* <Popconfirm
    //         title="Are you sure to delete this employee?"
    //         onConfirm={(e) => confirmDelete(userDetails.user_id)}
    //         placement="topRight"
    //         okText="Delete"
    //         cancelText="No"
    //       >
    //         <span className="cursorPointer delete">
    //           <CustIcon type="delete-o" />
    //         </span>
    //       </Popconfirm> */}
    //     </Space>
    //   ),
    // },
  ];

  const onFinish = (values) => {
    for (let [key, value] of Object.entries(values)) {
      if (!!value) {
        values[key] = "%" + value.trim() + "%";
        if(key === 'name'){
          let dt = [];
          values[key] = values[key].split(' ').filter(s => s).join(' ');
          dt = values[key]?.split(' ');
          values.fname = dt.length === 1 ? dt[0]?.trim() : dt[0]?.trim() + '%';
          values.lname = dt.length === 1 ? values.fname : dt.length > 1 ? '%' + dt[1]?.trim() : null;
        }
      } else {
        delete values[key];
      }
    }
    values.user_id = user_id;
    values.type_id = type_id;
    values.working_day = working_day;
    values.location_id = location_id;
    GET_LOCATION_BY_ID_QUERY({
      variables: values,
    });
    employeeSearchForm.setFieldsValue(values);
  };
  const confirmDelete = (value) => {};
  if (!formSet) {
    return <Loader />;
  }
  return (
    <Content className="site-body-layout">
      <section className="locationsEdit pt-2">
        <div className="secSubTitle pageSubTilte">
          <div className="stLeft">
            <h5>Edit location details</h5>
          </div>
          <div className="stright d-flex align-items-center"></div>
        </div>
        <Card className="locationsCard">
          <Row gutter={10}>
            <Col xs={24} lg={15} xl={15}>
              {/* <h4 className="locationName">
                {form.getFieldValue("location_name")}
              </h4> */}
              {formSet ? (
                <Form
                  form={form}
                  name="Location-edit"
                  // onFinish={onFinish}
                >
                  <Row gutter={[20, 20]}>
                    <Col xs={24} sm={12} xl={8}>
                      <Tooltip
                        trigger={["focus"]}
                        title="Location Name"
                        placement="topLeft"
                        overlayClassName="numeric-input"
                      >
                        <Form.Item name="location_name" label="">
                          <Input />
                        </Form.Item>
                      </Tooltip>
                    </Col>
                    <Col xs={24} sm={12} xl={8}>
                      <Tooltip
                        trigger={["focus"]}
                        title="Street address"
                        placement="topLeft"
                        overlayClassName="numeric-input"
                      >
                        <Form.Item name="street_address" label="">
                          <Input />
                        </Form.Item>
                      </Tooltip>
                    </Col>
                    <Col xs={24} sm={12} xl={8}>
                      <Tooltip
                        trigger={["focus"]}
                        title="Zip Code"
                        placement="topLeft"
                        overlayClassName="numeric-input"
                      >
                        <Form.Item name="zipcode" label="">
                          <Input onBlur={(e) => handleZipcodeChange(e)} />
                        </Form.Item>
                      </Tooltip>
                    </Col>
                    <Col xs={24} sm={12} xl={8}>
                      <Tooltip
                        trigger={["focus"]}
                        title="City"
                        placement="topLeft"
                        overlayClassName="numeric-input"
                      >
                        <Form.Item name="city" label="">
                          <Input disabled />
                        </Form.Item>
                      </Tooltip>
                    </Col>
                    <Col xs={24} sm={12} xl={8}>
                      <Tooltip
                        trigger={["focus"]}
                        title="State"
                        placement="topLeft"
                        overlayClassName="numeric-input"
                      >
                        <Form.Item name="state" label="">
                          <Input disabled />
                        </Form.Item>
                      </Tooltip>
                    </Col>
                    <Col xs={24} sm={12} xl={8}>
                      <Tooltip
                        trigger={["focus"]}
                        title="Country"
                        placement="topLeft"
                        overlayClassName="numeric-input"
                      >
                        <Form.Item name="country" label="">
                          <Input disabled />
                        </Form.Item>
                        <Input disabled type="hidden" />
                        <Input disabled type="hidden" />
                        {/* <Form.Item
                        name="location_id"
                        label=""
                        className="d-none"
                      >
                      </Form.Item>
                      <Form.Item
                        name="timezone_name"
                        label=""
                        className="d-none"
                      >
                      </Form.Item> */}
                      </Tooltip>
                    </Col>
                  </Row>
                </Form>
              ) : (
                <Loader />
              )}
            </Col>
            <Col xs={24} lg={9} xl={9}>
              <Card className="workingHours text-center ml-lg-3">
                <h3>Working hours</h3>
                <div className="timing d-flex flex-column">
                  <Row gutter={8} className="w-100">
                    <Col xs={24} sm={11} md={10} lg={11}>
                      <Tooltip
                        trigger={["focus"]}
                        title="Start Time"
                        placement="topLeft"
                      >
                        <Form.Item name="opening_time" className="mb-0">
                          <TimePicker
                            suffixIcon={null}
                            minuteStep={15}
                            defaultValue={moment(openingTime, "hh:mm a")}
                            format={"hh:mm a"}
                            className="w-100"
                            onChange={(time, timeString) =>
                              handleTimeChange({
                                time,
                                timeString,
                                type: "opening_time",
                              })
                            }
                          />
                        </Form.Item>
                      </Tooltip>
                    </Col>
                    <Col
                      xs={24}
                      sm={2}
                      md={4}
                      lg={2}
                      className="text-center py-2"
                    >
                      To
                    </Col>
                    <Col xs={24} sm={11} md={10} lg={11}>
                      <Tooltip
                        trigger={["focus"]}
                        title="End Time"
                        placement="topLeft"
                      >
                        <Form.Item name="closing_time">
                          <TimePicker
                            use12Hours
                            minuteStep={15}
                            showSecond={false}
                            suffixIcon={null}
                            placeholder="00:00 AM"
                            className="w-100"
                            format="hh:mm a"
                            defaultValue={moment(closingTime, "hh:mm A")}
                            onChange={(time, timeString) =>
                              handleTimeChange({
                                time,
                                timeString,
                                type: "closing_time",
                              })
                            }
                          />
                        </Form.Item>
                      </Tooltip>
                    </Col>
                  </Row>
                  <div className="typeTime">{timezone}</div>
                </div>
              </Card>
            </Col>
          </Row>
        </Card>
      </section>
      <section className="locEmployeeList pt-2">
        <div className="locEmployeeSearch mt-3">
          <Form name="basic" name={employeeSearchForm} onFinish={onFinish}>
            <Row gutter={16}>
              <Col xs={24} md={8} lg={6}>
                <Form.Item name="name">
                  <Input placeholder="Employee name" />
                </Form.Item>
              </Col>
              <Col xs={24} md={8} lg={8}>
                <Form.Item name="role_name">
                  <Input placeholder="Employee role" />
                </Form.Item>
              </Col>
              <Col xs={24} md={7} lg={10} className="text-md-right text-center">
                <Form.Item>
                  <Button
                    type="primary"
                    size="large"
                    shape="round"
                    htmlType="submit"
                    className="px-5"
                  >
                    Search
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
        <Card className="locEmployeeTableList">
          <Table loading={loading} columns={columns} dataSource={tableData} />
        </Card>
      </section>
    </Content>
  );
};
